import { css } from '@emotion/react';
import { LIGHT_YELLOW_COLOR, YELLOW_COLOR } from '../../styles/colors';
export const REVERIFY_PAGE_BUTTONS_CONTAINER_CSS = css `
  display: flex;
  flex-flow: row wrap;
  gap: 15px;
`;
export const REVERIFY_PAGE_USERNAME_CSS = css `
  color: ${LIGHT_YELLOW_COLOR};
`;
export const REVERIFY_PAGE_EMAIL_CSS = css `
  color: ${YELLOW_COLOR};
`;
